// extracted by mini-css-extract-plugin
export var circle = "_f8-1";
export var exitConfirmationModal = "_f8-5";
export var iframe = "_f8-0";
export var offline = "_f8-3";
export var online = "_f8-2";
export var workstationSelectError = "_f8-4";